import SimpleLoader from './SimpleLoader'
import PlaceholderMenu from './PlaceholderMenu'
import Pace from './Pace'
import WrapperLoader from './WrapperLoader'

export {
  SimpleLoader,
  PlaceholderMenu,
  Pace,
  WrapperLoader
}



// WEBPACK FOOTER //
// ./src/components/loaders/index.js